import * as lscache from "lscache";
import {Dispatch} from "redux";
import {createRequestActionTypes} from "@web2/ap-request-state";

import {fetchUserInfo} from "../../login/actions/get_user_info";
import {userIsAuthenticatedActionTypes} from "../../login/actions/login";
import {APLocalStorageKeys} from "../utils/ls_cache_keys";

const userSessionRestore = "user_session/RESTORE";
export const userSessionRestoreActionTypes = createRequestActionTypes(userSessionRestore);

export const restoreUserSession = () => async (dispatch: Dispatch) => {
    dispatch({type: userSessionRestoreActionTypes.start});
    const storedUserData = lscache.get(APLocalStorageKeys.USER_DATA);
    if (!storedUserData) {
        dispatch({type: userSessionRestoreActionTypes.error});
        return;
    }
    const userInfo = await dispatch(fetchUserInfo());
    if (userInfo) {
        dispatch({type: userIsAuthenticatedActionTypes.success, result: true});
        dispatch({type: userSessionRestoreActionTypes.success});
        return true;
    }
    return;
};
